import EventSeatIcon from "@material-ui/icons/EventSeat";

import QuotaPolicyList from "views/QuotaAllocation/QuotaPolicyList.js";
import CreateQuotaPolicy from "views/QuotaAllocation/CreateQuotaPolicy.js";
import DailyQuotaList from "views/QuotaAllocation/DailyQuotaList.js";
import QuotaMutationList from "views/QuotaAllocation/QuotaMutationList.js";
import GenerationRunList from "views/QuotaAllocation/GenerationRunList.js";
import QuotaErrorList from "views/QuotaAllocation/QuotaErrorList.js";

import { token } from "functions/Helper";

const agentQuota = () => {
  let views = [];
  if (
    token["booking.agent_quota_policies.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentQuotaPolicies",
      name: "Quota Policies",
      mini: "QP",
      component: QuotaPolicyList,
      layout: "/admin"
    });
  if (
    token["booking.agent_daily_quotas.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentDailyQuotas",
      name: "Daily Quota",
      mini: "DQ",
      component: DailyQuotaList,
      layout: "/admin"
    });
  if (
    token["booking.agent_daily_quotas.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentQuotaGenerationRuns",
      name: "Generation Runs",
      mini: "GR",
      component: GenerationRunList,
      layout: "/admin"
    });
  if (
    token["booking.agent_daily_quotas.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentQuotaMutations/Errors",
      name: "Quota Errors",
      mini: "QE",
      component: QuotaErrorList,
      layout: "/admin"
    });
  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Agent Quota",
        icon: EventSeatIcon,
        state: "agentQuotaCollapse",
        views: views
      }
    ];
  return [];
};

const agentQuotaHidden = () => {
  let views = [];
  if (
    token["booking.agent_quota_policies.write"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentQuotaPolicies/Create",
      name: "Create Quota Policy",
      component: CreateQuotaPolicy,
      layout: "/admin"
    });
  if (
    token["booking.agent_quota_mutations.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/AgentDailyQuotas/Detail",
      name: "Daily Quota Detail",
      component: QuotaMutationList,
      layout: "/admin",
      params: [{ name: "id" }]
    });
  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Agent Quota Hidden",
        state: "agentQuotaHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { agentQuota, agentQuotaHidden };
